// Centralized env var reads. Every VITE_* var is documented in .env.example.
// All have safe placeholder defaults so the app boots and runs in mock mode with zero setup.

export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://api.example.invalid',
  useMock: String(import.meta.env.VITE_USE_MOCK ?? 'true').toLowerCase() === 'true',
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN || 'https://your-domain.auth.us-east-1.amazoncognito.com',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || 'REPLACE_WITH_COGNITO_APP_CLIENT_ID',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'REPLACE_WITH_COGNITO_USER_POOL_ID',
  // Computed from the ACTUAL origin the app is being served from, not a build-time constant --
  // this app is served from more than one domain (the CloudFront default domain and
  // omnistspirituality.com/www), and a single static build can't bake in "the right one" for
  // both. Cognito just needs every real origin registered in its callback_urls/logout_urls
  // allowlist (see infrastructure/auth.tf) -- whichever one the user is actually on works.
  cognitoRedirectUri: `${window.location.origin}/auth/callback`,
  cognitoLogoutUri: `${window.location.origin}/`,
  cognitoScope: import.meta.env.VITE_COGNITO_SCOPE || 'openid email profile',
} as const;
